﻿import './components/menu.js';
import './components/checkout.js';

localStorage.setItem('theme', 'light');